<template>
    <div :class="$style.game">
      <!-- banner -->
      <img :class="$style.banner" :src="gameInfo.banner" alt="" />
      <!-- game -->
      <div :class="$style.gameWrap">
        <div :class="$style.game1">
          <img :src="gameInfo.icon" alt="" />
          <div :class="$style.inner">
            <h4>{{ gameInfo.appName }}</h4>
            <p>
              <span>{{ gameInfo.version != '0' ? `${gameInfo.version}·` : '' }}</span>
              <span v-for="category in gameInfo.categoryNames" :key="category">
                {{ category }}
              </span>
            </p>
            <div :class="$style.tags">
              <div
                v-for="(item, index) in gameInfo.tags"
                :key="index"
              >
                <span :style="{ backgroundColor: item.labelInfo, opacity: '0.2' }"></span>
                <span :style="{ color: item.labelInfo }">{{ item.labelName }}</span>
              </div>
            </div>
          </div>
          <div :class="$style.download">
            <p>综合评分</p>
            <div>
              <img :src="score" alt="">
              <span>{{ gameInfo.score }}</span>
            </div>
          </div>
        </div>
        <div :class="$style.extend">
          <div>
            <span>推荐指数：</span>
            <Rate
              v-model="rateScore"
              allow-half
              :size="11"
              color="#FD383C"
              void-icon="star"
              void-color="#eee"
              readonly
            ></Rate>
          </div>
          <div>
            <span>开服时间：</span>
            <span v-if="gameInfo.serviceInfo && gameInfo.serviceInfo.introduce" :class="$style.green">{{ gameInfo.serviceInfo.introduce }}</span>
            <span v-else-if="gameInfo.serviceInfo && gameInfo.serviceInfo.startTime" :class="$style.green">{{ moment(gameInfo.serviceInfo.startTime*1000).format('YYYY.MM.DD') }} ~ {{ moment(gameInfo.serviceInfo.endTime*1000).format('YYYY.MM.DD') || '' }}</span>
            <span v-else :class="$style.green">动态开服</span>
          </div>
        </div>
      </div>
      <!-- 活动详情 -->
      <div :class="$style.info">
        <h4 v-if="gameNews && gameNews.length">游戏资讯</h4>
        <div :class="$style.news" v-if="gameNews && gameNews.length">
          <div :class="$style.wrap">
            <div
              :class="$style.newsItem"
              v-for="(item, index) in gameNews"
              :key="index"
            >
              <img
                :src="item.icon"
                @click="preview(item)"
              />
              <div>
                <span>资讯</span>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <h4>游戏截图</h4>
        <div :class="$style.imageBar">
          <div :style="{ width: `${imageBarW}px` }">
            <img
              v-for="(item, index) in gameInfo.shots"
              :key="index"
              :class="gameInfo.imageStyle == 1 ? $style.heng : $style.shu"
              :src="item.image"
              @click="preview(item)"
            />
          </div>
        </div>
        <h4>游戏介绍</h4>
        <div v-html="gameInfo.introduce" :class="$style.infoDetail"></div>
        <div v-for="(item, index) in gameInfo.details" :key="index">
          <h4>{{ item.name }}</h4>
          <pre v-html="item.context"></pre>
        </div>
      </div>
      <!-- 下载按钮 -->
      <div :class="$style.icon">
        <div :class="$style.btn" @click="downloadBox">
          <img :src="down" alt="" />下载游戏
        </div>
      </div>
      <div :class="$style.placeholder"></div>
      
    </div>
  </template>
  
  <script>
  import { wxGameInfo, gameNews, burnPoint } from "@/apis/heziShare.js";
  import { ImagePreview } from 'vant';
  import { Rate } from "vant";
  import moment from 'moment';
  import { pageLoseTips, getCookie } from "@/libs/utils";
import { setPageTitle } from '@/bridge/AppJsBridge';
  
  export default {
    components: { Rate },
    data() {
      return {
        icon: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/download_icon.png",
        share: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/share.png",
        close: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/close.png",
        gift: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/libao_icon.png",
        down: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/down.png",
        score: "//static.hzwxbz3.cn/Lianyun/font_end/gameBox/score.png",
        gameInfo: {},
        isWX: false,
        rateScore: 0,
        imageBarW: 0,
        gameNews: [],
        moment
      };
    },
    created() {
      this.initData();
      setPageTitle('游戏详情')
    },
    methods: {
      preview(item) {
        ImagePreview([item.image || item.icon]);
      },
      async initData() {
        //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
        const ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        this.isWX = ua.match(/MicroMessenger/i) == "micromessenger";
        const { appkey } = this.$route.query;
        if (!appkey) {
          pageLoseTips(this.$toast);
          return
        }
        const pageCookie = getCookie();
        if (pageCookie) {
          for (const key in pageCookie) {
            if (Object.hasOwnProperty.call(pageCookie, key) && pageCookie[key] === 'null') {
              delete pageCookie[key]
            }
          }
        }
        this.cookie = pageCookie;
        const r = await wxGameInfo({ appkey: appkey });
        this.gameInfo = r.data;
        this.rateScore = this.handleRate(r.data.score);
        this.imageBarW =
          r.data.imageStyle == 1
            ? r.data.shots.length * 200
            : r.data.shots.length * 121;
  
        const gameNewsData = await gameNews({ appkey: this.$route.query.appkey, versionCode: this.$route.query.version || 1 })
        this.gameNews = gameNewsData.data
      },
      downloadBox() {
        burnPoint({
          event: 'h5_game_detail_download',
          appkey: this.$route.query.appkey,
          appName: this.gameInfo.appName,
          ...this.cookie
        })
        window.open(this.gameInfo.downloadUrl, '_blank');
      },
      download(type) {
        window.open(
          type == 1 ? this.gameInfo.downloadUrl : this.gameInfo.appUrl,
          "_blank"
        );
      },
      handleRate(rate) {
        let rateCopy = rate / 2;
        let integer = Math.floor(rate / 2);
        const decimal = rateCopy - integer;
        if (decimal >= 0.75) {
          integer = integer + 1
        } else if (decimal >= 0.5 && decimal < 0.75) {
          integer = integer + 0.5
        } else if (decimal >= 0.25 && decimal < 0.5) {
          integer = integer + 0.5
        }
        console.log(integer)
        return integer
      }
    },
  };
  </script>
  
  <style lang='scss' module>
  .game {
    width: 100%;
    height: 100%;
    background-color: #F6F6F6;
    padding-bottom: 100px;
    .title {
      width: 100%;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN, Source Han Sans CN-Bold;
      font-weight: 700;
      color: black;
      line-height: 36px;
    }
  
    .banner {
      width: 100%;
      object-fit: cover;
    }
    .gameWrap {
      width: calc(100% - 20px);
      margin: 7px 10px;
      padding: 10px 5px 5px 5px;
      background-color: #FFFFFF;
      border-radius: 6.94px;
      .game1 {
        background-color: #FFFFFF;
        display: flex;
        margin-bottom: 5px;
        > img {
          width: 69px;
          height: 69px;
          display: inline-block;
          margin-right: 12px;
        }
    
        .inner {
          width: 200px;
          height: 100%;
          > h4 {
            font-size: 15px;
            font-family: Source Han Sans CN, Source Han Sans CN-Bold;
            font-weight: 500;
            text-align: left;
            color: #333333;
            line-height: 26px;
            margin-bottom: 9px;
          }
          > p {
            width: 100%;
            font-size: 11px;
            font-family: SourceHanSansCN, SourceHanSansCN-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 12px;
          }
          .tags {
            width: 100%;
            height: 14px;
            display: flex;
            margin-top: 6px;
            > div {
              display: inline-block;
              padding: 2px 6px;
              line-height: 12px;
              box-sizing: border-box;
              border-radius: 2px;
              text-align: center;
              font-size: 9px;
              margin-right: 4px;
              position: relative;
              > span:nth-child(1) {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 2px;
                // z-index: -1;
              }
            }
          }
        }
    
        .download {
          position: absolute;
          right: 30px;
          font-size: 11px;
          color: #FF612C;
          text-align: center;
          margin-left: 20px;
          padding-top: 20px;
          > p {
            display: inline-block;
            margin-bottom: 5px;
          }
          > div {
            font-size: 17px;
            > img {
              width: 10px;
              height: 10px;
            }
          }
        }
      }
      .extend {
        display: flex;
        justify-content: space-between;
        font-size: 9px;
        > div {
          width: 49%;
          background: #f8f8f8;
          border-radius: 5.21px;
          padding: 8px 0;
          text-align: center;
          .green {
            color: #5FC661;
          }
        }
      }
    }
  
    .info {
      width: 360px;
      min-height: 200px;
      background: #FFFFFF;
      border-radius: 8px;
      margin: 0px auto 10px auto;
      padding: 13px 10px 10px 10px;
      .infoDetail {
        color: #999999;
        font-size: 13px;
        line-height: 15px;
      }
      .imageBar {
        width: 100%;
        overflow-x: auto;
        margin-bottom: 10px;
        > div {
          display: flex;
          > img {
            margin-right: 10px;
          }
          .heng {
            width: 200px;
            height: 100px;
            object-fit: cover;
          }
          .shu {
            width: 121px;
            height: 216px;
            object-fit: cover;
          }
        }
      }
      .news {
        width: 100%;
        overflow-x: auto;
        .wrap {
          white-space:nowrap;
          display: flex;
          > div {
            flex: none;
            width: 167.71px;
            height: 146.88px;
            margin-right: 10px;
            background: #f9fbff;
            border-radius: 6.94px;
            overflow: hidden;
            > img {
              width: 100%;
              height: 95px;
            }
            > div {
              width: 100%;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2; /* 这里是超出几行省略 */
              overflow: hidden;
              white-space: initial;
              font-size: 12.5px;
              color: #666666;
              line-height: 16px;
              padding-top: 5px;
              > span:nth-child(1) {
                color: #76B4E8;
                border: 1px solid #76B4E8;
                font-size: 9px;
                padding: 0 1px;
                margin-right: 1px;
              }
            }
          }
        }
      }
      > div {
        margin-bottom: 10px;
      }
      h4 {
        width: 100%;
        font-size: 16px;
        font-family: SourceHanSansCN, SourceHanSansCN-Medium;
        font-weight: 600;
        text-align: left;
        color: #333333;
        line-height: 25px;
        margin-bottom: 6px;
      }
      pre {
        width: 100%;
        font-size: 13px;
        font-family: SourceHanSansCN, SourceHanSansCN-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #999999;
        line-height: 21px;
        white-space: pre-wrap;
        word-wrap: break-word;
      }
    }
    .placeholder {
      width: 100%;
      height: 59px;
    }
    .icon {
      width: 100%;
      height: 59px;
      position: fixed;
      bottom: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
  
      .btn {
        width: 347px;
        height: 38px;
        background: #FD383C;
        border-radius: 19px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
        font-family: SourceHanSansCN, SourceHanSansCN-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        > img {
          width: 14px;
          margin-right: 6px;
        }
      }
    }
    .share {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 10;
      > img:nth-child(1) {
        width: 100%;
      }
      > img:nth-child(2) {
        width: 20px;
        display: block;
        margin: 30px auto;
      }
    }
    .download1 {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 10px;
      width: 300px;
      height: 40px;
      font-size: 15px;
      margin: auto;
      border-radius: 40px;
      background: #fc5f5e;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }
  </style>